import { marketPlace } from '@/axios'

export default {
  changeOrderStatus (id, status) {
    return marketPlace().patch(`merchant/orders/${id}`, { status: status })
  }
}
